import { Component, ChangeDetectionStrategy } from '@angular/core';
import { untranslatedString } from 'models/translated-string';
import { CsPage } from 'providers/nav-controller';
import { ToastController } from 'providers/toast-controller';
import { ToastType } from 'components/toast/toast-host';

@Component({
    selector: 'page-test-ui-toasts',
    templateUrl: 'test-ui-toasts.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestUiToastsPage extends CsPage<{}> {
  // Configuration properties
  toastMessage: string = 'Hello! This is a test toast message 🎉';
  toastType: string = 'success-light';
  toastAtTop: boolean = false;
  closeButtonType: string = 'default';
  toastDuration: string = '3000';
  includeAction: boolean = false;
  includeDontShowAgain: boolean = false;
  actionButtonText: string = 'Learn More';

  constructor(
    private toastCtrl: ToastController
  ) {
    super();
  }

  showConfiguredToast() {
    // Build toast options based on configuration
    const options: any = {
      message: untranslatedString(this.toastMessage || 'Test toast message'),
      type: this.toastType as ToastType,
      position: this.toastAtTop ? 'top' : 'bottom'
    };

    // Handle duration (0 means persistent)
    const durationMs = parseInt(this.toastDuration, 10) || 0;
    if (durationMs > 0) {
      options.duration = durationMs;
    }

    // whether the toast offers a close at all. its SHAPE is not chosen here: since #5116 the
    // component picks a worded button when there is a button row and the corner mark when there
    // is not. custom text only reaches the screen in the worded case.
    if (this.closeButtonType === 'none') {
      options.showCloseButton = false;
    } else if (this.closeButtonType === 'dismiss') {
      options.showCloseButton = true;
      options.closeButtonText = untranslatedString('Dismiss Now');
    } else {
      options.showCloseButton = true;
    }

    // if "never show" is wanted, the toast needs a uniqueId - that is the key the setting
    // records. a FRESH id per press, because pressing the button is the whole point of testing
    // it, and a fixed id would make ToastController silently drop every later toast.
    if (this.includeDontShowAgain) {
      options.showDontShowAgainButton = true;
      options.uniqueId = `test-ui-toast-${Date.now()}`;
    }

    // Handle action button
    if (this.includeAction) {
      options.actionButtonText = untranslatedString(this.actionButtonText || 'Action');
      options.onAction = () => {
        console.log('Action button clicked!');
      };
    }

    // Show the toast
    this.toastCtrl.showToast(options);
  }
}